/**
 * Per diem estimator gate. The API is authoritative and 404s when its own flag
 * is off, so this only decides whether the event page bothers to ask.
 */
export function isPerDiemEstimatorEnabled(): boolean {
  const raw = (import.meta.env.VITE_GSA_PER_DIEM_ENABLED ?? '').trim().toLowerCase();
  return raw === 'true' || raw === '1';
}
